import { useSelector } from "react-redux";
import { useRequest } from "redux-query-react";
import { BASE_PATH } from "api/ux/src";
const getImageRequestParams = (imageUrl, requestConfig) => {
    const requestUrl = BASE_PATH + imageUrl;
    return {
        options: {
            headers: {
                requestBlob: "true"
            },
            method: "GET"
        },
        queryKey: `GetImage-${requestUrl}`,
        transform: requestConfig?.transform,
        update: requestConfig?.update,
        url: requestUrl
    };
};
const getRequestParams = (imageUrl) => {
    const requestParams = getImageRequestParams(imageUrl, {
        transform: (response) => ({ Image: { [imageUrl]: URL.createObjectURL(response) } }),
        update: {
            Image: (prevValue, transformedValue) => ({ ...prevValue, ...transformedValue })
        }
    });
    return requestParams;
};
export const useImage = (imageUrl, imageIsExternalContent) => {
    const requestParams = imageIsExternalContent ? null : getRequestParams(imageUrl);
    const [queryState, refresh] = useRequest(requestParams);
    const imageSrc = useSelector((state) => state.entities?.Image[imageUrl]);
    return [imageIsExternalContent ? imageUrl : imageSrc, queryState, refresh];
};
